import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PhotoUpload from '../../../../components/PhotoUpload';
import TextInputNoob from '../../../../components/input/TextInputNoob';
import TextAreaEditor from '../../../../components/TextAreaEditor';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { objectHasValue } from '../../../../helpers/helpers';
import moment from 'moment';
import { postTour } from '../action';
import Button from '../../../../components/Button';
import './style.scss';

const CreatePariwisata = ({ history, uploadPhoto, uploadTour, postTour }) => {
  const [textValue, setTextValue] = useState('');
  const [titleValue, setTitleValue] = useState('');
  const [wisataSekitar, setWisataSekitar] = useState('');
  const [tags, setTags] = useState('');
  const [location, setLocation] = useState('');
  const defaultForm = {
    title: titleValue,
    image_url: objectHasValue(uploadPhoto.data) ? uploadPhoto.data.data.url : '',
    content: textValue,
    place: location,
    location: '0,0',
    nearest_places: wisataSekitar === '' ? [] : wisataSekitar.split(','),
    tags: tags === '' ? [] : tags.split(',')
  };

  const submitEvent = () => {
    postTour(defaultForm);
  };

  if (uploadTour.status === 'resolve') {
    window.location.reload();
  }

  return (
    <div className='create-events'>
      <div className='header'>TAMBAH PARIWISATA</div>
      <div className='content'>
        <PhotoUpload />
        <span style={{ height: 10, display: 'inline-block' }} />
        <span style={{ height: 5, display: 'inline-block' }} />
        <div className='div-2 div-wrap'>
          <div className='div-wrap-2' style={{ paddingRight: 20 }}>
            <TextInputNoob
              label='Judul *'
              action={setTitleValue}
              placeholder='Masukkan Judul'
            />
          </div>
          <div className='div-wrap-2' style={{ paddingRight: 20 }}>
            <TextInputNoob
              label='Lokasi *'
              action={setLocation}
              placeholder='Masukkan lokasi'
            />
          </div>
        </div>
        <div className='div-2 div-wrap' style={{ display: 'none' }}>
          <div className='div-wrap-2 select' style={{ paddingRight: 20 }}>
            <label>Status *</label>
            <select name='staus' id='status'>
              <option value='Aktif'>Aktif</option>
              <option value='Non Aktif'>Non Aktif</option>
            </select>
          </div>
          <div className='div-wrap-2 select'>
            <label>Kategori *</label>
            <select name='staus' id='status'>
              <option value='NATURE, SCIENCE LANDSCAPE AND WILDLIFE'>
                NATURE, SCIENCE LANDSCAPE AND WILDLIFE
              </option>
              <option value='ARTIFACT'>ARTIFACT</option>
            </select>
          </div>
        </div>
        <span style={{ height: 5, display: 'inline-block' }} />
        <TextAreaEditor label='Deskripsi *' action={setTextValue} />
        <TextInputNoob
          label='Tags *'
          action={setTags}
          placeholder='Masukkan tag tanpa menggunakan spasi setelah koma'
        />
        <TextInputNoob
          label='Tempat Wisata Terdekat *'
          action={setWisataSekitar}
          placeholder='Masukkan nama tempat tanpa menggunakan spasi setelah koma'
        />
        <span style={{ height: 5, display: 'inline-block' }} />
        <div className='btn-wrap'>
          <Button color='link' type='button' onClick={() => history.goBack()}>
            Cancel
          </Button>
          <Button
            color='primary'
            type='submit'
            className='pass-btn'
            onClick={() => submitEvent()}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

CreatePariwisata.propTypes = {
  history: PropTypes.object,
  uploadPhoto: PropTypes.object,
  uploadTour: PropTypes.object,
  postTour: PropTypes.func
};

const mapStateToProps = (state) => ({
  uploadPhoto: {
    status: state.uploadPhotoGeneral.status,
    error: state.uploadPhotoGeneral.error,
    data: state.uploadPhotoGeneral.data
  },
  uploadTour: {
    status: state.newTourReducerAdmin.status
  }
});

export default compose(
  connect(mapStateToProps, { postTour }),
  withRouter
)(CreatePariwisata);
